import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Send, CheckCircle2, User, MessageSquare, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { supabase } from '../../lib/supabase';


const ContactPage = () => {
  const { t } = useTranslation();  
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 // Dodaj state na vrh komponente:
const [isLoading, setIsLoading] = useState(false);

const handleSubmit = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  try {
    const { data, error } = await supabase.functions.invoke('send-contact-email', {
      body: formData,
    });

    if (error) throw error;

    console.log("Email inviata con successo:", data);
    setSubmitted(true);

    // Reset forme
    setTimeout(() => {
      setSubmitted(false);
      setFormData({ name: '', email: '', subject: '', message: '' });
    }, 4000);

  } catch (err) {
    console.error("Errore invio mail:", err);
    alert("Errore nell'invio del messaggio. Riprova più tardi.");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-background pt-24 pb-20 px-4">
      <div className="max-w-3xl mx-auto">
        
        <div className="relative z-50"> 
          <button 
            onClick={() => navigate(-1)} 
            className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors mb-8 group cursor-pointer bg-transparent border-none p-0"
          >
            <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
            {t('contact.back')}
          </button>
        </div>

        <div className="text-center space-y-4 mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 text-primary rounded-full mb-4">
            <Mail size={32} />
          </div>
          <h1 className="text-4xl font-black uppercase tracking-tighter">{t('contact.title')}</h1>
          <p className="text-muted-foreground text-sm uppercase tracking-[0.2em] font-bold">{t('contact.subtitle')}</p>
        </div>

        {submitted ? (
          <div className="bg-card border border-primary/20 p-12 rounded-[2.5rem] text-center space-y-6 shadow-xl animate-in fade-in zoom-in duration-300">
            <div className="flex justify-center">
              <CheckCircle2 size={64} className="text-primary animate-bounce" />
            </div>
            <div className="space-y-2">
              <h2 className="text-2xl font-black uppercase italic">{t('contact.success_title')}</h2>
              <p className="text-muted-foreground">{t('contact.success_desc')}</p>
            </div>
          </div>
        ) : (
          <section className="bg-card p-8 md:p-12 rounded-[2.5rem] border border-border shadow-sm">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="text-[10px] uppercase tracking-widest font-black text-muted-foreground ml-2">{t('contact.label_name')}</label>
                  <div className="relative">
                    <User className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" size={18} />
                    <input 
                      required
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder={t('contact.placeholder_name')}
                      className="w-full bg-background border border-border rounded-2xl py-4 pl-12 pr-4 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all"
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-[10px] uppercase tracking-widest font-black text-muted-foreground ml-2">{t('contact.label_email')}</label>
                  <div className="relative">
                    <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-muted-foreground" size={18} />
                    <input 
                      required
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@mail.com"
                      className="w-full bg-background border border-border rounded-2xl py-4 pl-12 pr-4 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all"
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] uppercase tracking-widest font-black text-muted-foreground ml-2">{t('contact.label_subject')}</label>
                <input 
                  required
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder={t('contact.placeholder_subject')}
                  className="w-full bg-background border border-border rounded-2xl py-4 px-6 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all"
                />
              </div>

              <div className="space-y-2">
                <label className="text-[10px] uppercase tracking-widest font-black text-muted-foreground ml-2">{t('contact.label_message')}</label>
                <div className="relative">
                  <MessageSquare className="absolute left-4 top-6 text-muted-foreground" size={18} />
                  <textarea 
                    required
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder={t('contact.placeholder_message')}
                    className="w-full bg-background border border-border rounded-2xl py-5 pl-12 pr-6 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all resize-none"
                  ></textarea>
                </div>
              </div>

              <button 
                type="submit"
                className="w-full bg-primary text-primary-foreground font-black uppercase tracking-tighter py-5 rounded-2xl flex items-center justify-center gap-3 hover:opacity-90 active:scale-[0.98] transition-all shadow-lg shadow-primary/20"
              >
                {t('contact.btn_send')}
                <Send size={20} />
              </button>
            </form>
          </section>
        )}

        <div className="mt-12 text-center space-y-6">
          <div className="flex flex-col md:flex-row justify-center items-center gap-8">
            <div className="space-y-1">
              <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-bold">{t('contact.info_email')}</p>
              <a href="mailto:info@orizon-aix.com" className="text-foreground font-black hover:text-primary transition-colors">info@orizon-aix.com</a>
            </div>
            <div className="space-y-1">
              <p className="text-[10px] uppercase tracking-widest text-muted-foreground font-bold">{t('contact.info_web')}</p>
              <a href="https://orizon-aix.com" target="_blank" rel="noopener noreferrer" className="text-foreground font-black hover:text-primary transition-colors">www.orizon-aix.com</a>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ContactPage;